import { library } from "@fortawesome/fontawesome-svg-core";
import { faPrint } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Component } from "react";
import Back from "../../components/goBack";
import birs from "../../static/birs.png";
import "./Certificate.css";

library.add(faPrint);

export default class Certificate extends Component {
  state = {
    showButton: true,
    info: ""
  };

  componentDidMount() {
    this.getTpInfo(JSON.parse(localStorage.MobileBntinId));
  }
  goBack = () => {
    this.props.history.push("/viewtp");
  };

  getTpInfo = data => {
    this.setState({ info: data });
  };

  printCert = () => {
    this.setState({ showButton: false }, () => {
      window.print();
      this.setState({ showButton: true });
    });
  };

  render() {
    let button = this.state.showButton ? (
      <button className="printBtn" onClick={this.printCert}>
        <FontAwesomeIcon icon="print" />
      </button>
    ) : null;

    let back = this.state.showButton ? (
      <Back clickHandler={this.goBack} />
    ) : null;

    let today = new Date();
    let date =
      today.getDate() +
      "-" +
      (today.getMonth() + 1) +
      "-" +
      today.getFullYear();
    return (
      <div className="cont">
        {back}
        <div className="certContainer">
          <img src={birs} alt="img" />
          <table className="table">
            <tbody className="tableBody">
              <tr>
                <td>KGTIN</td>
                <td>{this.state.info.TIN}</td>
              </tr>
              <tr>
                <td>SURNAME</td>
                <td>{this.state.info.surname}</td>
              </tr>
              <tr>
                <td>FIRSTNAME</td>
                <td>{this.state.info.first_name}</td>
              </tr>
              <tr>
                <td>MIDDLENAME</td>
                <td>{this.state.info.middle_name}</td>
              </tr>
              <tr>
                <td>LGA</td>
                <td>{this.state.info.lga}</td>
              </tr>
              <tr>
                <td>WARD</td>
                <td>{this.state.info.ward}</td>
              </tr>
              <tr>
                <td>STATE</td>
                <td>BENUE</td>
              </tr>
              <tr>
                <td>TAX STATION</td>
                <td>{this.state.info.tax_office}</td>
              </tr>
              <tr>
                <td>DATE OF REGISTRATION</td>
                <td>{this.state.info.createtime}</td>
              </tr>
              <tr>
                <td>DATE OF ISSUE</td>
                <td>{date}</td>
              </tr>
            </tbody>
          </table>
          {button}
        </div>
      </div>
    );
  }
}
